export default {
    list: 'PartnerAffiliation',
    columns: {
        Id: {
            class: 'id',
            dataName: 'Id',
            type: 'number',
            title: 'Id',
            width: 100,
            hidden: true,
            readOnly: false
        },
        PartnerId: {
            class: "lookup",
            dataName: 'PartnerId',
            type: 'number',
            title: 'PartnerId',
            width: 100,
            hidden: true,
            readOnly: false
        },
        PartnerID: {
            class: "lookup",
            dataName: 'Partner/PartnerID',
            type: 'number',
            title: 'PartnerID',
            width: 100,
            hidden: true,
            readOnly: true
        },
        PartnerFullName: {
            class: "lookup",
            dataName: 'Partner/FullName',
            type: 'string',
            title: 'PartnerFullName',
            width: 100,
            hidden: true,
            readOnly: true
        },
        AffiliatedPartnerId: {
            class: "lookup",
            dataName: 'AffiliatedPartnerId',
            type: 'number',
            title: 'AffiliatedPartnerId',
            width: 100,
            hidden: true,
            readOnly: false
        },
        AffiliatedPartnerID: {
            class: 'value',
            dataName: 'AffiliatedPartner/PartnerID',
            type: 'string',
            title: 'Partner ID',
            width: 100,
            hidden: false,
            readOnly: true,
            editable: false,
			template: "<span class='AffiliatedPartnerID'>#=AffiliatedPartnerID #</span>"
        },
        AffiliatedPartnerFullName: {
            class: 'choice',
            dataName: 'AffiliatedPartner/FullName',
			dropdown: true,
            type: 'string',
            title: 'Partner Name',
            hidden: false,
            readOnly: true,
			width:150,
        },
    }
}